import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { useGetSelectedDocuments } from '../../hooks/useGetSelectedDocuments.ts';
import type { GoogleDrivePickerDoc } from '../../services/GoogleAPIs/GoogleDrivePicker.ts';
import type { OneDriveFileType } from '../../services/OneDriveAPIs/OneDriveTypes.ts';

import { WarningModal } from './WarningModal.tsx';

export const i18n: {
	RestrictionWarningModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	RestrictionWarningModalBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	RestrictionWarningModalSubmit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	RestrictionWarningModalTitle: {
		id: 'import-from-sources.warning-modal.RestrictionWarningModalTitle',
		defaultMessage: 'No restrictions on child pages',
		description:
			'Message in the modal header indicating that pages are not restricted and all users can view them.',
	},
	RestrictionWarningModalBody: {
		id: 'import-from-sources.warning-modal.RestrictionWarningModalBody',
		defaultMessage:
			'You don’t have permission to restrict content in this space. Anyone in your organization can view and edit all content imported here.',
		description:
			'Message in modal body indicating that pages are not restricted and all users can view them.',
	},
	RestrictionWarningModalSubmit: {
		id: 'import-from-sources.warning-modal.RestrictionWarningModalSubmit',
		defaultMessage: 'Continue',
		description: 'Submit button text for the RestrictionWarningModal',
	},
});

export const RestrictionWarningModal: React.FC<{
	onSubmit: (docs: (GoogleDrivePickerDoc | File | OneDriveFileType)[]) => void;
	onClose: () => void;
}> = ({ onSubmit, onClose }) => {
	const { documentsToUpload } = useGetSelectedDocuments();

	const handleRetry = () => onSubmit(documentsToUpload);
	return (
		<WarningModal
			onSubmit={handleRetry}
			onClose={onClose}
			headText={<FormattedMessage {...i18n.RestrictionWarningModalTitle} />}
			bodyText={<FormattedMessage {...i18n.RestrictionWarningModalBody} />}
			submitText={<FormattedMessage {...i18n.RestrictionWarningModalSubmit} />}
		/>
	);
};
